﻿// Set up accessibility 
var keys = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    RIGHT: 39,
};

// Transform enter key press to click.
// Don't bind "clickable" for other use.
$(document).off('keydown', '.clickable');
$(document).on('keydown', '.clickable', function (e) {
    if ((e.keyCode || e.which) === keys.ENTER) {
        e.target.click();
    }
});

// Enable keyboard action on toolbar, users can reach each button using "left" and "right".
function toolbarButtonKeydown(e) {
    if (e.keyCode !== keys.LEFT && e.keyCode !== keys.RIGHT) {
        return;
    }

    var $toolbarDiv = $(this);
    var $enabledButtons = $toolbarDiv.closest('[role=toolbar]').find('[role=button]').not('.grid-menu-disabled');
    var indexOfSelectedButton = $enabledButtons.index($toolbarDiv);
    switch (e.keyCode) {
        case keys.LEFT:
            indexOfSelectedButton --;
            break;
        case keys.RIGHT:
            indexOfSelectedButton ++;
            break;
    }
    if (indexOfSelectedButton >= 0 && indexOfSelectedButton < $enabledButtons.length ) {
        $enabledButtons[indexOfSelectedButton].focus();
    }
    e.stopPropagation();
    return false;
}

$(document).on('keydown', '[role=toolbar] [role=button]', toolbarButtonKeydown);

//get the first and last elements that could have focus
function getFocusItemsAtBothEnds($root) {
    var $focusElements = $root.find('a[href], area[href], button, details, input, iframe, select, textarea, [tabindex]').not('[tabindex^="-"]').not('[disabled]').filter(":visible");
    var $firstElement, $lastElement, lowestTabindex, highestTabindex, tabindex;
    $firstElement = $lastElement = $focusElements.eq(0);
    if ($focusElements.length) {
        lowestTabindex = highestTabindex = $firstElement.attr('tabindex') || '0';

        $focusElements.each(function (index, element) {
            tabindex = $(element).attr('tabindex') || '0';
            if (tabindex >= highestTabindex) {
                highestTabindex = tabindex;
                $lastElement = $(element);
            }
            else if (tabindex < lowestTabindex) {
                lowestTabindex = tabindex;
                $firstElement = $(element);
            }
        });
    }
    return { firstElement: $firstElement, lastElement: $lastElement };
}

function dialogKeydown(e) {
    if (e.altKey || e.ctrlKey) {
        return true;
    }
    if (e.keyCode !== keys.TAB && e.keyCode !== keys.ESC) {
        return true;
    }

    var $this = $(this);
    var $activeElement = $(document.activeElement);
    var items = getFocusItemsAtBothEnds($this);
    switch (e.keyCode) {
        case keys.TAB:
            if (items.firstElement.index($activeElement) == 0 && e.shiftKey) {
                items.lastElement.focus();
            }
            else if (items.lastElement.index($activeElement) == 0 && !e.shiftKey) {
                items.firstElement.focus();
            }
            else {
                e.stopPropagation();
                return true;
            }
            break;
        case keys.ESC:
            $('.closeimage:not(.disableEsc)').click();
            $("#alert-popup-dismiss").click();
            break;
    }

    e.stopPropagation();
    return false;
}

$(document).on('keydown', '[role=dialog]', dialogKeydown);